import { Directive, Input, ElementRef, Renderer2, HostListener } from "@angular/core";

@Directive({
  selector: "[hoverClass]"
})
export class HoverClassDirective {
  @Input("hoverClass") hoverClass: string;

  constructor(
    public elementRef: ElementRef,
    private renderer: Renderer2
  ) { }

  @HostListener("mouseover") mouseOver() {
    this.renderer.addClass(this.elementRef.nativeElement, this.hoverClass);
  }

  @HostListener("mouseout") mouseOut() {
    this.renderer.removeClass(this.elementRef.nativeElement, this.hoverClass);
  }
}